<template>
  <div v-if="shippingAddress">
    <HContainer>
      <template #content>
        <HBorderPanel>
          <template #heading>{{ heading }}</template>
          <template #body>
            <p
              v-for="(val, key) in shippingAddress"
              :key="key"
              v-html="val"
            ></p>
          </template>
        </HBorderPanel>
      </template>
    </HContainer>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HBorderPanel from "@/general/components/pages/parts/PointHistoryList/HBorderPanel.vue";

@Options({
  props: {
    shippingAddress: { type: [Array, Boolean], default: false },
    heading: { type: String, default: "お届け先情報" }
  },
  components: {
    HContainer,
    HBorderPanel
  }
})
export default class HShippingDetails extends Vue {
  shippingAddress!: any[] | boolean;
  heading!: string;
}
</script>
